import { render, staticRenderFns } from "./BalletClasses.vue?vue&type=template&id=5b40c942"
import script from "./BalletClasses.vue?vue&type=script&lang=js"
export * from "./BalletClasses.vue?vue&type=script&lang=js"
import style0 from "./BalletClasses.vue?vue&type=style&index=0&id=5b40c942&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports